export const M_STATUS = {
  4: {
    color: 'blue',
    text: 'Ajuan',
  },
  5: {
    color: 'success',
    text: 'Diterima',
  },
  6: {
    color: 'red',
    text: 'Ditolak',
  },
  8: {
    label: 'Dibatalkan',
    color: 'red'
  },
}

export const M_KONFIRMASI = {
  5: {
    label: 'Setujui Mutasi',
    color: 'success'
  },
  6: {
    label: 'Tolak Mutasi',
    color: 'red'
  },
  8: {
    label: 'Dibatalkan',
    color: 'red'
  },
}
